export function getBetIds(selection) {
  return { id: selection.replace('OB_OU', '') }
}
